/* global TimeoutId */

/**
 * Simple single-subscriber timer implementation.
 */
export default class Timer {
  private timeout: TimeoutId | undefined;

  public constructor(private readonly onTimeout: () => void) {}

  /**
   * Trigger timeout in `milliseconds`. Calling when already
   * `timer.isRunning` is a noop. If you want to ensure that the
   * timer is restarted, call `.stop()` first.
   */
  public start(milliseconds: number): void {
    if (this.isRunning) {
      return;
    }

    this.timeout = setTimeout(() => {
      this.timeout = undefined;
      this.onTimeout();
    }, milliseconds);

    return;
  }

  public stop(): void {
    if (!this.isRunning) {
      return;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = undefined;

    return;
  }

  public get isRunning(): boolean {
    return this.timeout !== undefined;
  }
}
